import React from "react"
import { GatsbyImage } from "gatsby-plugin-image";
import styled, { css } from "styled-components"
import { motion } from "framer-motion"

import Icon from "../global/icon"

const size = {
  tablet: 850,
  mini: 768,
  mobile: 600,
}
const below = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const CorporateReviewWrapper = styled(motion.div)`
  max-width: 466px;
  overflow: hidden;
  border-radius: 10px 10px 0 0;
  ${below.mini`
  max-width: initial;
  `}
`

const ReviewWrapper = styled.div`
  border: 1px solid var(--ice-grey);
  padding: 0 24px 24px;
  border-radius: 0 0 10px 10px;
  margin-bottom: 64px;
  background-color: rgba(248, 250, 252, 1);
  ${below.mini`
  margin-bottom: 24px;
  `}
`
const ReviewContainer = styled.div`
  transform: translateY(-28px);
  ${below.mobile`
    transform: translateY(-20px);
  `}
`

const Review = styled.p`
  font-size: 22px;
  line-height: 28px;
  color: var(--alt-black);
  margin: 16px 0;
  ${below.mobile`
  font-size: 16px;
    line-height: 20px;`}
`
const Reviewer = styled.div`
  font-weight: 600;
  font-size: 22px;
  line-height: 28px;
  text-align: right;
  color: var(--alt-black);
  &.expanded {
    color: ${props => props.quoteColor || null};
  }
  ${below.mini`
  text-align: left;
  `}
  ${below.mobile`
  font-size: 16px;
line-height: 20px;
  `}
`
const Source = styled.div`
  font-size: 16px;
  line-height: 20px;
  text-align: right;
  color: var(--grey);
  ${below.mini`
  text-align: left;
  `}
  ${below.mobile`
  font-size: 14px;
line-height: 16px;
  `}
`
const IconContainer = styled.div`
  position: relative;
  ${below.mobile`
  svg {
    width:40px;
    height:40px;
  }
  `}/* ::after {
    position: absolute;
    left: 0;
    top: 0;
    content: "";
    width: 56px;
    height: 56px;
    background-color: white;
    border-radius: 50%;
    z-index: -1;
    transform: translate(-1px, -1px);
  } */
`

const CorporateReviewCard = props => {
  return (
    <CorporateReviewWrapper layout>
      <div
        style={{
          maxHeight: 296,
          overflow: "hidden",
          minHeight: 296,
          position: "relative",
        }}
      >
        <GatsbyImage
          image={props.image}
          alt={props.altText}
          style={{
            position: "absolute",
            zIndex: "-1",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            width: "100%",
            height: "100%",
            filter: `brightness(${props.brightness})`,
          }} />
      </div>

      <ReviewWrapper>
        <ReviewContainer>
          <IconContainer>
            <Icon
              icon="quote-circle-56"
              backgroundColor="#0274e8"
              quoteColor="white"
            />
          </IconContainer>

          <Review>{props.review}</Review>
          <Reviewer>{props.reviewer}</Reviewer>
          <Source>{`${props.source}`}</Source>
        </ReviewContainer>
      </ReviewWrapper>
    </CorporateReviewWrapper>
  );
}

export default CorporateReviewCard
